import {
  Heading,
  Box,
  Center,
  Text,
  Button,
  useColorModeValue,
  Link,
} from '@chakra-ui/react';

import { FaPlay, FaCheckCircle, FaClock } from 'react-icons/fa';
import LogoIcon from '../customIcons/LogoIcon'

import './courseCard.scss';

const defaultAvatar = 'https://images.unsplash.com/photo-1520810627419-35e362c5dc07?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ'


export default function CourseCard(props) {

  return (
    <Center py={6} className="course-wrapper">
      <Box
        className="course-card"
        w={'full'}
        bg={useColorModeValue('white', 'gray.900')}
        boxShadow={'2xl'}
        rounded={'lg'}
        p={6}
        textAlign={'center'}
      >
        <img
          className="course-image"
          src={props.image || defaultAvatar}
        />
        <Heading
          className="course-title"
          backgroundColor={'brand.main'}
        >
          <LogoIcon
            className="course-title-icon"
            color='white'
          />
          <Heading
          className="course-title-text"
          fontSize={'3xl'}
          fontFamily={'body'}
          >
            { props.name || ''}
          </Heading>
        </Heading>
        <div className="text-wrapper">
          <Text
            textAlign={'center'}
            color={'brand.black'}
            px={3}>
            { props.info || ''}
          </Text>
          <Text fontSize={'sm'} fontWeight={600} color={'brand.black'} mt={2} className="course-duration">
          <FaClock /> { props.duration || '20 minutes'}
          </Text>
          <Link 
            href={props.link || '/learn'}
            isExternal
            _hover={{
              textDecoration: 'none',
            }}
          >
            <Button
              rightIcon={ props.completed ? <FaCheckCircle /> : <FaPlay />}
              rounded={'full'}
              bg={'brand.main'}
              color={'white'}
              _hover={{
                bg: 'brand.dark',
                textDecoration: 'none',
              }}
            >
              { props.completed ? 'Completed ' : 'Start' }
            </Button>
          </Link>
        </div>
      </Box>
    </Center>
  );
}